import styled from 'styled-components';
import { colors } from '../../common/ui/globalColors';

export const StyledCollectionStatus = styled.div`
    .title-wrapper {    
        h1 {
            .building-address {
                margin-bottom: 18px;
                font-size: 20px;
                line-height: 26px;
                color: var(--bllink-gray);
                display: block;
                margin-inline-start: 0;
                text-align: start;
            }
        }
    }

    .react-switch-selector-wrapper {
        max-width: 600px;
        margin-bottom: 22px;
        direction: ltr;

        .react-switch-selector-option-label {
            margin: 8px 0;
        }  
    }  
    
    .switch-btns-wrapper {
        display: flex;
        gap: 11px;
        margin-bottom: 31px;
        
        .switch-btn {
            width: fit-content;
            height: 38px;
            border: 1px solid rgba(110, 116, 255, 0.2);
            border-radius: 100px;
            font-size: 16px;
            line-height: 18px;
            position: relative;
            cursor: pointer;
            padding: 9px 13px;
            display: flex;
            align-items: center;
            gap: 10px;

            img {
                margin-inline-end: 4px;
            }

            .radio-btn-outer {
                width: 16px;
                height: 16px;
                border: 1px solid rgba(110, 116, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                .radio-btn-inner {
                    width: 6.4px;
                    height: 6.4px;
                    background: rgba(110, 116, 255, 0.2);
                    border-radius: 50%;
                }
            }
        }

        .switch-btn.active {
            background-color: #E9E9FD;
            color: rgba(55, 54, 71, 0.7);
            border: none;

            .radio-btn-outer {
                border: 1px solid #6A92FF;

                .radio-btn-inner {
                    background: linear-gradient(50.53deg, #6A92FF 20.83%, #8764FF 86.02%);
                }
            }
        }

        .switch-btn.disabled {
            pointer-events: none;
        }
    }

    .bank-deposit-switches {
        margin-top: -11px;
        margin-bottom: 20px;
        gap: 17px;

        .switch-btn {
            font-size: 14px;
            line-height: 22px;
            padding: 8px 23px;
            gap: 30px;
        }

        .switch-btn.active {
            background-color: #E9E9FD;
            color: #373647;
        }
    }

    .main-wrapper {
        border: 1px solid rgba(110, 116, 255, 0.4);
        border-radius: 28px;
        padding: 19px 25px;

        .report {
            border-bottom: 1px solid rgba(110, 116, 255, 0.4);
            padding-bottom: 16px;
            margin-bottom: 17px;
            margin-right: 23px;
            direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
            
            .general-headers, .report-top {
                display: grid;
                grid-template-columns: 1fr 2fr 1fr 1fr;
                gap: 30px;
            }
    
            .general-headers {
                font-weight: 700;
                font-size: 17px;
                color: rgba(55, 54, 71, 0.7);
            }
    
            .report-top {
                align-items: center;
                position: relative;
                margin-top: 25px;
                // margin-right: ${(({ ltr }) => ltr ? '' : '30px')};
        
                .search input {
                    max-width: 200px;
                }
        
                .datepickers-container {
                    display: flex;
                    gap: 28px;
        
                    .input-item label {
                        text-align: start;
                    }
                }
        
                .datepicker-label {
                    position: absolute;
                    top: -20px;
                    left: 2px;
                    font-size: 12px;
                    color: rgba(55, 54, 71, 0.7);
                }
            }
    
            .total-amount {
                font-size: 17px;
                color: rgba(55, 54, 71, 0.7);
    
                .total {
                    font-weight: 700;
                    line-height: 25px;
                }
            }
        }

        #section-to-print {
            position: absolute; 
            bottom: 5000px;
            width: 100%;
    
            .tool {
                display: none;
            }
        }
    }
`

export const StyledCharges = styled.div`
    .outside-headers {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(8, 1fr);
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        font-weight: 700;
        font-size: 14px; 
        line-height: 25px;       
        color: rgba(55, 54, 71, 0.7);
        margin-bottom: 12px;
        margin-left: 87px;
        margin-right: 65px;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
    }

    .outside-headers.deposit {
        grid-template-columns: repeat(7, 1fr);
    }

    .records-cards-wrapper {
        display: flex;
        flex-direction: column;
        gap: 14px;
        margin-right: 20px;
    }

    #section-to-print {
        position: absolute; 
        bottom: 5000px;
        width: 100%;

        .tool {
            display: none;
        }
    }
`

export const StyledCard = styled.div`
    position: relative;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

    .body-card {
        padding: 9px 36px;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid #A8C0FF;
        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 11px;
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(8, 1fr);
        color: rgba(55, 54, 71, 0.7);
        text-align: center;
        margin-left: 50px;
        align-items: center;
        font-size: 14px;

        .tenant {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .currency-value {
            justify-content: center;
        }

        .payment-type {
            cursor: pointer;
            position: relative;

            .inside-type {
                border-bottom: 1px solid rgba(55, 54, 71, 0.7);
                padding-bottom: 3px;

                img {
                    margin-inline-start: 5px;
                }
            }
        }
    }

    .body-card.deposit {
        grid-template-columns: repeat(7, 1fr);
    }

    .payment-info {
        margin-left: 50px;
        padding: 7px 37px 0;
        display: grid;
        grid-template-columns: ${({ bllinkCharges }) => bllinkCharges ? 'repeat(8, 1fr)' : 'repeat(7, 1fr)'};
        gap: 20px;
        text-align: center;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

        .info-list {
            display: flex;
            flex-direction: column;
            color: rgba(55, 54, 71, 0.7);
            font-size: 12px;
            line-height: 22px;
            text-align: start;

            .highlited-info {
                font-weight: 700;
            }

            .more-details {
                line-height: 25px;
            }
        }
    }

    .tool {
        width: 32px;
        height: 32px;
        background-color: ${colors.additionalColors.lightGray};
        border-radius: 50px;
        cursor: pointer;
        position: absolute;
        left: 3px;
        top: 5px;
        display: flex;
        flex-direction: column;
        gap: 3px;
        align-items: center;
        justify-content: center;
        box-shadow: -2px 3px 7px 0 rgba(89, 102, 137, 0.35);

        .dot {
            background-color: var(--bllink-purple);
            width: 4px;
            height: 4px;
            border-radius: 50px;
        }

        :hover {
            background: linear-gradient(180deg, #6E8EFF 0%, #8469FF 100%);
            color: #FFFFFF;

            .dot {
                background-color: #FFFFFF;
            }
        }

    }
` 